"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Text = exports.Rectangle = exports.Container = void 0;

var _taggedTemplateLiteral2 = _interopRequireDefault(require("@babel/runtime/helpers/taggedTemplateLiteral"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _palette = require("../../../styles/palette");

var _widths = require("../../../styles/widths");

var _templateObject, _templateObject2, _templateObject3;

var Container = _styledComponents["default"].div(_templateObject || (_templateObject = (0, _taggedTemplateLiteral2["default"])(["\n  display: flex;\n  flex-direction: row;\n"])));

exports.Container = Container;
Container.displayName = 'Container';

var Rectangle = _styledComponents["default"].div(_templateObject2 || (_templateObject2 = (0, _taggedTemplateLiteral2["default"])(["\n  width           : 24px;\n  height          : 2px;\n  align-self      : center;\n  background-color: ", ";\n"])), function (props) {
  return props.color || _palette.palette.success;
});

exports.Rectangle = Rectangle;
Rectangle.displayName = 'Rectangle';

var Text = _styledComponents["default"].p(_templateObject3 || (_templateObject3 = (0, _taggedTemplateLiteral2["default"])(["\n  padding    : 0 ", "px;\n  font-size  : 12px;\n  line-height: 1.33;\n  text-align : left;\n  color      : ", ";\n"])), _widths.widths.base, _palette.palette.bobBlack);

exports.Text = Text;
Text.displayName = 'Text';